export default "__VITE_ASSET__qvZst5jC__"